module.exports = __webpack_public_path__ + "static/media/alumni11.01aab326.mp4";